module.exports = __webpack_public_path__ + "img/slider3.jpg?37bee097f9c22e75a70370f905ef65ae";